import { render, staticRenderFns } from "./ChatGeoMessage.vue?vue&type=template&id=467155c9&scoped=true&lang=pug&"
import script from "./ChatGeoMessage.vue?vue&type=script&lang=js&"
export * from "./ChatGeoMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatGeoMessage.vue?vue&type=style&index=0&id=467155c9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467155c9",
  null
  
)

export default component.exports